import * as React from 'react';
import { connect } from 'react-redux';
import { addWarrantyToQuote } from '../../../../actions/salesActions';
import './WarrantyDecleration.css';

class WarrantyDecleration extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            concent: false,
            nextDisabled: true,
            submitted: false,
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleSwitch = this.handleSwitch.bind(this);
        this.checkSubmit = this.checkSubmit.bind(this);
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
    }

    async handleNext() {
        await this.setState({ submitted: true })
        if (!this.state.nextDisabled) {
            await this.props.dispatchAction(addWarrantyToQuote())
        }
    }

    async handleSwitch(e: any) {
        let checked = e.target.checked;
        await this.setState({ concent: checked });
        await this.checkSubmit();
    }

    async checkSubmit() {
        const { concent } = this.state;

        if (concent) {
            await this.setState({ nextDisabled: false });
        } else {
            await this.setState({ nextDisabled: true });
        }
    }

    public render() {
        return (
            <div className="text-center justify-content-center">
                <div className="declaration">
                    <p className="text-red"><b>It's super important to let us know if the following happens<br />
                        (if you don't, it could affect your future claims)</b></p>
                    <ul className="mb-15px mt-15px">
                        <li className="mb-10px text-left">Once your car reaches 200,000kms. (In this case, only a percentage of your original cover will remain. Check our KPPD for more info.)</li>
                        <li className="text-left">Your car's sold, stolen, or hi-jacked (and not recovered) or written off.</li>
                    </ul>
                    <p className="kppd">Please refer to our <a target="_blank" href="/Content/documents/King-price-insurance-policy.pdf">KPPD</a> here for a list of the parts we cover and how much they're covered for. It's your responsibility to check this list, we're not liable to cover any costs not stated on it.</p>
                </div>
                <div className="form-group pt-4 pb-3">
                    <div className="row">
                        <div className="col ItcConcent">
                            <div className="switch">
                                <input type="checkbox" id="ItcConcent" name="concent" onChange={this.handleSwitch} />
                                <label className="switch-normal" htmlFor="ItcConcent">Okay, got it.</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="help-block-v2 font-size-14px text-center">
                    {this.state.submitted ? <div>You need to accept the decleration</div> : null}
                </div>
                <button className="btn btn-solid-red" id='Next' style={{ width: '200px' }} disabled={this.state.nextDisabled} onClick={this.handleNext}>Next</button>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WarrantyDecleration);